exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".due[data-v-57dd0d3a]{padding-left:35px!important;background-image:url(/assets/icons/bell--red.svg);background-repeat:no-repeat;background-position:10px}", ""]);

// exports
